module.exports = __webpack_public_path__ + "img/jm1.234c32cd.png";